<template>
<div>
    <div v-for="(gen, i) in list" :key="gen.id">
        <div class="d-flex align-start ml-2 mt-0" v-if="!validateIsEmpty(gen.name)">
            <div class="mr-2">{{i+1}}.</div>
            <div>
                <div>{{gen.name}}</div>
                <div class="mt-n1 body-2 grey--text text--darken-2" v-if="!validateIsEmpty(gen.org)">
                    <v-icon size="12px" color="cyan">fa-angle-right</v-icon>
                    {{gen.org}}
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['list']
}
</script>